import React, { useEffect, useContext } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import { addUser } from '../../contexts/UserProvider/actions';
import { UserContext } from '../../contexts/UserProvider/context';
import Api from '../../config/api';
import environment from '../../config/environment';

function AuthAnonymous() {
  const userContext = useContext(UserContext);
  const { userDispatch } = userContext;
  useEffect(() => {
    // Capture the onAuthStateChanged unsubscribe so the listener is torn down
    // on unmount / hot-reload — otherwise it accumulates and we get duplicate
    // callbacks during dev. Wrapped in an async IIFE because setPersistence
    // is awaited before the listener is set up.
    let unsubscribe = () => {};
    let cancelled = false;
    (async () => {
      // Force the most durable persistence available (IndexedDB → localStorage
      // → in-memory) so a redirect to a third-party domain (e.g. Stripe
      // hosted checkout) and back doesn't wipe the user's session.
      try {
        await firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      } catch (e) {
        // Non-fatal: even if persistence can't be upgraded (rare browser
        // restrictions) we still want to set up the auth listener below.
      }
      if (cancelled) return;
      unsubscribe = firebase.auth().onAuthStateChanged((userath) => {
        if (userath) {
          const user = userath.toJSON();
          localStorage.setItem('accessToken', user.stsTokenManager.accessToken);
          Api.get(`/${environment.yapps.stripePath}/active-subscription`)
            .then((result) => {
              user.isSubscriber = result.data.status == 'ACTIVE' ? true : false;
              user.subscriptionID = result.data.subscriptionID;
              if (user.displayName == null) {
                user.displayName = user.email;
              }
              addUser(userDispatch, user);
            })
            .catch((err) => {
              user.isSubscriber = false;
              if (user.displayName == null) {
                user.displayName = user.email;
              }
              addUser(userDispatch, user);
            });
        } else {
          // Don't auto-anonymize on the post-Stripe return page: if Firebase
          // failed to restore the session across the third-party redirect, we
          // want the success page to surface a "log back in" CTA rather than
          // silently replace the user's identity with a brand-new anonymous
          // uid (which would orphan the just-created subscription).
          if (window.location.pathname !== '/checkout-success') {
            firebase.auth().signInAnonymously();
          }
        }
      });
    })();
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [userDispatch]);

  return <></>;
}

export default AuthAnonymous;
